export default "__VITE_ASSET__eb4e2be8__"